<template>
    <div v-resize ="onResize">
        <drop
            class        = "cut"
            @drop        = "onDrop"
            mode         = "cut"
            accepts-type = "inb-message-selectable"
        >
        <v-container class="site-selected" :style="style" >
            <div class="v-label v-label--active theme--light primary--text mb-1" v-if="showTitle">
                Anlagen
            </div>
            <drag
                v-for    = "item in sites"
                :data    = "item"
                :key     = "item.id"
                @cut     = " onRemove(item)"
                type     = "inb-message"
            >
                <v-card
                    flat
                    rounded
                    :class="cardstyle?'card-style':'list-style'"
                    style="padding-right: 5px; "
                >
                    <div >
                        <div class="v-flex" style="justify-content: space-between">
                            <div style="font-size: 14px">Fabrik-Nr. {{ item.fabricNo }}</div>
                            <div v-if="navigate"><a @click="onSite(item)"><i class="fa fa-arrow-left mr-2 primary--text"></i></a></div>
                        </div>
                        <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
                    </div>
                    <v-divider v-if="!cardstyle" class="mt-1 mb-0"/>
                </v-card>
            </drag>

            <div class="v-flex" :class="cardstyle?'mt-1 ml-3':'mt-0'" style="justify-content: space-between;">
                <v-menu
                    v-if                    = "!readonly"
                    v-model                 = "edit"
                    min-width               = "450"
                    max-width               = "450"
                    transition              = "scale-transition"
                    :close-on-content-click = "false"
                    :close-on-click         = "false"
                    :offset-x               = "true"
                    :left                   = "cardstyle"
                    :right                  = "!cardstyle"
                    nudge-top="-20"
                    absolute
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div class="v-flex">
                            <a
                                v-bind = "attrs"
                                v-on   = "on"
                                class  = "pt-1"
                            >
                                <i class="fas fa-plus"></i>
                            </a>
                            <span class="ml-2 mt-1 ">Anlagen hinzufügen</span>
                        </div>
                    </template>

                    <div class="site-selectable">
                        <div class="v-flex primary white--text" style="height: 35px; padding-top: 5px">
                            <v-spacer />
                            <a class="white--text"> <i class="mr-1" />Auswahl Anlagen</a>
                            <v-spacer />
                            <a class="fas fa-times white--text pr-3 pt-1" @click="onClose"></a>
                        </div>

                        <div class="v-flex">
                            <v-text-field
                                hide-details
                                class         = "mt-0 pt-5 mb-3"
                                @input        = "onInput"
                                @click:append ="fullsearch=!fullsearch"
                                :append-icon  = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
                                v-model       = "sitesearch"
                                :label        = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
                                autocomplete="off"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false"
                            />
                        </div>

                        <v-container class="site-seletable-content">
                            <drag
                                v-for="item in selectable"
                                @cut       = "onCut(item)"
                                :key       = "item.id"
                                :data      = "item"
                                type       = "inb-message-selectable"
                                @dragstart = "onDragStart"
                                @dragend   = "onDragEnd"
                            >
                                <div class="dragable-card">
                                    <div class="v-flex primary--text" style="justify-content: space-between">
                                        <div>Fabrik-Nr. {{ item.fabricNo }} {{ item.customer.name }} </div>
                                    </div>
                                    <div class="card-subtitle ">{{ item.type ? item.type.name : '' }}</div>
                                    <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
                                    <div class="card-subtitle">
                                        {{ item.ve  ? item.ve  : '-/-' }},
                                        {{ item.ve2 ? item.ve2 : '-/-' }},
                                        {{ item.ve3 ? item.ve3 : '-/-' }}
                                    </div>
                                </div>
                            </drag>
                        </v-container>
                    </div>
                </v-menu>

                <drop
                    v-if         = "!readonly"
                    class        = "cut"
                    @drop        = "onTrash"
                    mode         = "cut"
                    accepts-type = "inb-message"
                >
                    <div class="trash">
                        <a
                            draggable="false"
                        ><i class="fas fa-trash-alt primary--text"></i></a>
                    </div>
                </drop>
            </div>
        </v-container>
        </drop>
    </div>
</template>

<script>

import Site from "@/modules/msd/unit/service/Site";
import { Drop, Drag, } from "vue-easy-dnd";

export default {
    name: "CSiteSelectMultiple",

    components: {
        Drop,
        Drag,
    },

    props: {
        customer: {
            required: true,
            type    : Object,
        },

        sites: {
            required: true
        },

        cardstyle: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        maxHeight: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        navigate: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        fullsearch: false,
        edit      : false,
        sitesearch: "",
        selectable: [],
        height    : null
    }),

    computed: {
        style () {
            if (this.maxHeight) {
                return 'max-height: ' + this.maxHeight + 'px';
            }

            return this.height ? 'max-height: ' + this.height + 'px' : ''
        },
    },

    methods: {
        onResize () {
            this.height = window.innerHeight - 15;
        },

        onInsert(event) {
            console.log(event)
           // this.items.splice(event.index, 0, event.data);
        },

        onInput () {
            if (this.sitesearch.length === 0) {
                this.selectable = [];
                return;
            }

            if (this.fullsearch) {
                this.searchFull(this.sitesearch);
            } else {
                this.search(this.sitesearch)
            }
        },

        onDrop (event) {
            const id = event.data.id;
            if (this.sites.find(site => site.id === id)) {
                this.edit = true;
                return;
            }

            this.sites.splice(event.index, 0, event.data);
            this.sites.sort ((l, r) => {
                if (l < r) return -1;
                if (l > r) return 1;
                return 0;
            });

            this.edit = true;
            this.$emit("changed", this.sites);
        },

        onCut () {
        },

        onRemove (item) {
            const index = this.sites.findIndex (site => site.id === item.id);
            this.sites.splice(index, 1);
            this.$emit("changed", this.sites);
        },

        onClose () {
            this.edit = false;
        },

        onSite (site) {
            const context = this.$store.getters.context;
            context.site = site.id;
            this.$store.dispatch("setContext", context);
        },

        onDragStart () {
            this.$emit("dragging", true)
        },

        onDragEnd () {
            this.edit = true;
            this.$emit("dragging", false)
        },

        search (value) {
            const filter = {
                onlyLiftmanagement: false
            }

            Site.search(this.customer.id, value, false, filter).then((data) => {
                this.selectable = data;
            });
        },

        searchFull (value) {
            const filter = {
                onlyLiftmanagement: false
            }

            Site.search(this.customer.id, value, true, filter).then((data) => {
                this.selectable = data;
            });
        },

        onTrash () {

        }
    }
}
</script>

<style scoped>

.card-style {
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey!important;
    padding: 10px;
    margin: 0 0 10px 5px;
}

.list-style {
    padding: 0;
    height: 50px
}

.site-selected {
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 3px;
    min-height: 20px;
    width: calc(100% + 10px);
}

.site-selectable {
    height: 500px;
    background-color: white;
    padding: 15px;
    border-radius: 10px;
}

.site-seletable-content {
    max-height: 375px;
    overflow-y: scroll;
    padding-right: 5px;
    padding-left: 0;
}

.card-subtitle {
    font-size: 11px;
}

.dragable-card {
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey!important;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    background-color: white;
}

.trash {
    width: 55px;
    padding-left: 20px;
    height: 36px;
    padding-top: 6px;
    margin-top: -6px;
    border-radius: 5px;
}

.trash i {
    padding-top: 6px;
    padding-bottom: 6px;
}

div::-webkit-scrollbar {
    width: 8px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3)!important;
    border-radius: 5px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 5px;
}

</style>
